let meta = {
  facebookAppId: '114317532324632',
  appTitle: '我們會吃光海洋嗎？從太平洋到西非，兩岸漁業全景調查',
  facebookShareDescription: '近二十年中國遠洋漁業崛起，超越台灣成為另類「海上強權」，它把南極蝦帶上了中國尋常人家的餐桌。但在此同時，公眾也看到不規範的台灣漁業收到了歐盟的「黃牌」；欠缺規範的「海盜式」撈捕從中國傳到了西非。捕魚如何成了無止境的掠奪？請看端傳媒從太平洋到西非洲做全景式報導。',
  sinaweiboShareTitle: '近二十年中國遠洋漁業崛起，超越台灣成為另類「海上強權」，它把南極蝦帶上了中國尋常人家的餐桌。但在此同時，公眾也看到不規範的台灣漁業收到了歐盟的「黃牌」；欠缺規範的「海盜式」撈捕從中國傳到了西非。捕魚如何成了無止境的掠奪？請看端傳媒從太平洋到西非洲做全景式報導。',
  twitterShareTitle: '近二十年中國遠洋漁業崛起，超越台灣成為另類「海上強權」，它把南極蝦帶上了中國尋常人家的餐桌。但在此同時，公眾也看到不規範的台灣漁業收到了歐盟的「黃牌」；欠缺規範的「海盜式」撈捕從中國傳到了西非。捕魚如何成了無止境的掠奪？請看端傳媒從太平洋到西非洲做全景式報導。'
}

export default meta



/** WEBPACK FOOTER **
 ** ./src/meta_data.js
 **/